module.exports = __webpack_public_path__ + "static/frontUserNew/img/brand.e9e69513.gif";